import { useSelector } from "react-redux";
import LoginWarning from "../Consumer/Components/LoginWarning";

const RouteProtector = ({ children }) => {
  const loggedIn = useSelector((x) => x.LoggedIn);
  if (!loggedIn) {
    return <LoginWarning />;
  }
  return children;
};

export default RouteProtector;
